module.exports = ".padtop10 {\r\n  padding-top: 10px\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/with-pod/with-pod.component.css
// module id = ./src/app/with-pod/with-pod.component.css
// module chunks = main